import FormGroup from "@mui/material/FormGroup";
// import TextField from "@mui/material/TextField";
import Input from "@mui/material/Input";
import React from "react";
import {IconButton, InputAdornment} from "@mui/material";
import {Visibility, VisibilityOff} from "@mui/icons-material";

export default function LoginScreenPassword(props) {

     const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

    return (
      <FormGroup>
          <Input
              fullWidth={true}
              autoFocus={true}
              inputRef={input => input && input.focus()}
              id="password"
              disabled={props.isLoading}
              type={props.passwordVisibility && props.passwordVisibility.password === false ? "password" : "text"}
              label="Password"
              autoComplete="new-password"
              onChange={props.handlePasswordFieldChange}
              endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                disabled={props.isLoading}
                onClick={(e) => props.handleTogglePasswordVisibility(e, "password")}
                onMouseDown={handleMouseDownPassword}
                size="large">
                {props.passwordVisibility.password ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          }

          />

          {/*    <TextField*/}
          {/*    fullWidth={true}*/}
          {/*    autoFocus={true}*/}
          {/*    inputRef={input => input && input.focus()}*/}
          {/*    id="password"*/}
          {/*    disabled={props.isLoading}*/}
          {/*    type={props.passwordVisibility && props.passwordVisibility.password === false ? "password" : "text"}*/}
          {/*    label="Password"*/}
          {/*    autoComplete="new-password"*/}
          {/*    onChange={props.handlePasswordFieldChange}*/}

          {/*/>*/}

      </FormGroup>
    );
}